/**
 * @deprecated Use `formatNumber()` instead
 */
export const putCommasIntoNumber = (n: number | string) => n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
